import { AxiosResponse } from 'axios'
import { HttpClient } from '@opallabs/api'

type DuplicateWorkflow = (id: string) => Promise<AxiosResponse>

const duplicateWorkflow: DuplicateWorkflow = (id) =>
  HttpClient().post(
    `${window.location.origin}/workflows/v2/workflows/${id}/duplicate`,
    { data: { type: 'workflow' } }
  )

export default duplicateWorkflow
